/*
 * @Author: huangzq
 * @Date: 2020-04-09 20:17:21
 * @Last Modified by: zhouwei
 * @Last Modified time: 2020-06-06 18:22:37
 * @Desc: 内部-课程列表页面
*/
<template>
  <div class="inside-course-list">
    <!-- 课程表格 -->
    <div class="table-wrapper">
      <list-biz
        :config="tableConfig"
        :data="tableData"
        :page="apiParams.page"
        :total="total"
        :page-size="apiParams.pageSize"
        :table-loading="tableLoading"
        @on-current-change="handleOnCurrentChange"
        @on-statistics-click="handleOnStatisticsClick"
        @on-edit-click="handleOnEditClick"
        @on-status-click="handleOnChangeStatusClick"
        @on-delete-click="handleOnDeleteClick"
      >
        <ds-search
          slot="search"
          :form-schema="searchFormConfig"
          @on-search-click="handleOnSearchClick"
          @on-reset-click="handleOnResetClick"
        >
          <mk-button
            slot="toolbar"
            type="primary"
            icon="el-icon-plus"
            @click="handleOnOpenClick"
          >
            新建课程
          </mk-button>
        </ds-search>
      </list-biz>
    </div>

    <mk-dialog-confirm
      :visible.sync="isShowConfirmDialog"
      v-bind="confirmDialogData"
      append-to-body
      @on-confirm="isShowConfirmDialog=false"
    />
  </div>
</template>

<script>
import { MBASVCAPIS } from '@api'

import TableConfig from './course-table-components/index.js'
import tagSelectCascader from '@components/tag-select-cascader'
export default {
  name: 'InsideCourseList',
  data () {
    return {
      // 表格loading
      tableLoading: true,
      // 课程列表数据
      tableData: [],

      // 当前页面所用的接口api数据
      apiMap: {
        // 获取列表数据
        getList: MBASVCAPIS.CourseApi.courseListPost,
        // 停用｜启用
        changeStatus: MBASVCAPIS.CourseApi.courseChangeStatusPut,
        // 删除课程
        deleteOne: MBASVCAPIS.CourseApi.courseDeleteDelete
      },

      // 获取课程列表接口参数
      apiParams: {
        // 名称
        name: '',
        page: 1,
        pageSize: 10,
        // 状态：0(所有状态)
        status: 0,
        // 标签ID列表
        tags: []
      },
      // 列表总条数
      total: 0,

      // 表格的配置
      tableConfig: TableConfig,

      // 搜索表单的配置
      searchFormConfig: {
        name: {
          type: 'string',
          value: '',
          defaultValue: '',
          label: '',
          width: '200',
          placeholder: '请输入名称',
          ui: {
            widget: 'MkInput', // 组件名
            widgetConfig: {} // 组件配置
          }
        },
        tags: {
          type: 'Array',
          value: [],
          defaultValue: [],
          width: '320',
          placeholder: '选择标签（多选）',
          ui: {
            widget: tagSelectCascader, // 组件名
            widgetConfig: {// 组件配置
              tip: false,
              maxNum: 0
            }
          }
        },
        status: {
          type: 'number',
          value: null,
          defaultValue: null,
          label: '',
          width: '200',
          placeholder: '状态',
          ui: {
            widget: 'DsSearchSelect', // 组件名
            // 组件配置
            widgetConfig: {
              // 初始化数据
              data: [
                // {
                //   value: 0,
                //   label: '全部'
                // },
                {
                  value: 1,
                  label: '启用'
                },
                {
                  value: 2,
                  label: '停用'
                }
              ]
            }
          }
        }
      },

      // 删除失败弹窗相关的
      isShowConfirmDialog: false,
      confirmDialogData: {}
    }
  },
  created () {
    this.getDataByApi()
  },
  methods: {
    // 通过接口获取课程列表数据
    async getDataByApi () {
      this.tableLoading = true
      const res = await this.apiMap.getList(this.apiParams)

      if (res.success) {
        this.tableData = res.data.data
        this.total = res.data.total
      }
      this.tableLoading = false
    },

    // 分页change事件
    handleOnCurrentChange (page) {
      this.apiParams.page = page
      this.getDataByApi()
    },

    // 搜索事件
    handleOnSearchClick (res) {
      let tags = this.util.levelTagsToTags(this.searchFormConfig.tags.value)
      this.apiParams = {
        ...this.apiParams,
        ...res,
        tags: tags
      }
      this.apiParams.page = 1
      this.getDataByApi()
    },

    // 重置事件
    handleOnResetClick (res) {
      this.apiParams = {
        ...this.apiParams,
        ...res
      }
      this.apiParams.page = 1
      this.getDataByApi()
    },

    // 跳转到课程编辑or新建页面
    toCourseCreateEditPage (query = {}) {
      this.$router.push({
        path: '/business-school/course-manage/course-create-edit',
        query
      })
    },

    // 课程事件
    handleOnOpenClick () {
      this.toCourseCreateEditPage()
    },

    // 表格：统计分析事件
    handleOnStatisticsClick ({ row }) {
      this.$router.push({
        path: '/business-school/course-manage/statistical-data',
        query: {
          id: row._id
        }
      })
    },

    // 表格：编辑事件
    handleOnEditClick ({ row }) {
      this.toCourseCreateEditPage({ id: row._id })
    },

    // 表格：停用、启用事件
    async handleOnChangeStatusClick ({ row }) {
      const res = await this.apiMap.changeStatus({
        _id: row._id,
        status: row.status === 1 ? 2 : 1
      })

      if (res.success) {
        this.getDataByApi()
      }
    },

    // 表格：删除事件
    async handleOnDeleteClick ({ row }) {
      const res = await this.apiMap.deleteOne({
        _id: row._id
      })

      if (res.success) {
        if (res.code === 20002001) {
          this.confirmDialogData = {
            title: '删除失败',
            tip: '该课程已关联学习任务，不能被删除，请先从任务中移除',
            closeBtn: {
              isShow: false
            },
            confirmBtn: {
              type: 'primary',
              color: '#fff',
              text: '确 认',
              isShow: true
            }
          }

          // 已关联任务 不可删除
          this.isShowConfirmDialog = true
        } else {
          // 删除成功
          this.$message.success('删除成功')
          this.getDataByApi()
        }
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.inside-course-list {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 10px 20px;
  box-sizing: border-box;
  overflow: hidden;

  .table-wrapper {
    flex: 1;
    // 该高度没啥用的，但是不写的话，flex:1不生效
    height: 0;
  }
}
</style>
